
import { useState } from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Investor, Contact } from "@/types/investor";
import SearchBar from "@/components/contacts/SearchBar";
import SortControls from "@/components/contacts/SortControls";
import ContactsTable from "@/components/contacts/ContactsTable";
import { filterAndSortContacts, getInvestorForFirm, isInvestorProcessed } from "@/components/contacts/utils";

interface ContactsListProps {
  contacts: Contact[];
  investors: Investor[];
}

const ContactsList = ({ contacts, investors }: ContactsListProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortField, setSortField] = useState<"name" | "firmName" | "relevance">("name");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  
  console.log("ContactsList - Rendered with contacts:", contacts.length);
  console.log("ContactsList - Rendered with investors:", investors.length);
  
  // Toggle sort direction
  const toggleSortDirection = () => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
  };

  // Handle sort field change
  const handleSortChange = (field: "name" | "firmName" | "relevance") => {
    if (sortField === field) {
      toggleSortDirection();
    } else {
      setSortField(field);
      setSortDirection(field === "relevance" ? "desc" : "asc"); // Relevance defaults to desc
    }
  };

  // Get filtered and sorted contacts
  const sortedAndFilteredContacts = filterAndSortContacts(
    contacts,
    investors,
    searchTerm,
    sortField,
    sortDirection
  );

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <SortControls 
          sortField={sortField} 
          sortDirection={sortDirection} 
          handleSortChange={handleSortChange} 
        />
      </div>

      <ScrollArea className="h-[calc(100vh-250px)]">
        <ContactsTable 
          contacts={sortedAndFilteredContacts}
          investors={investors}
          getInvestorForFirm={(firmName) => getInvestorForFirm(investors, firmName)}
          isInvestorProcessed={isInvestorProcessed}
        />
      </ScrollArea>
    </div>
  );
};

export default ContactsList;
